export default __webpack_public_path__ + "assets/img/AccessLoginLogo.3951dca1.svg";